/** Datos de demostración — Fase 1 mock; sin backend ni persistencia. */

export const DESPACHO_MOCK_NOTICE =
  "Vista operativa en preparación. En esta etapa los mensajes pueden ser demostrativos; la persistencia y notificaciones reales se implementarán en Fase 2.";

export const dashboardKpis = [
  { id: "vencidas", label: "Tareas vencidas", value: 4, tone: "critical", href: "/despacho/tareas?estatus=vencido" },
  { id: "por_vencer", label: "Tareas por vencer", value: 11, tone: "warn", href: "/despacho/tareas?estatus=por_vencer" },
  { id: "en_proceso", label: "Tareas en proceso", value: 18, tone: "info", href: "/despacho/tareas?estatus=en_proceso" },
  { id: "sin_auxiliar", label: "Clientes operativos sin auxiliar", value: 3, tone: "warn", href: "/despacho/clientes?sin_auxiliar=1" },
  { id: "pendientes_aux", label: "Pendientes por auxiliar", value: 26, tone: "neutral", href: "/despacho/reportes?report=pending_tasks" },
  { id: "mensajes", label: "Mensajes recientes", value: 7, tone: "info", href: "/despacho/mensajes" },
  { id: "carga", label: "Carga de trabajo (equipo)", value: "78%", tone: "neutral", href: "/despacho/tareas" },
  { id: "vencimientos", label: "Vencimientos próximos", value: 9, tone: "warn", href: "/despacho/reportes?report=upcoming_due_dates" },
];

export const mockClientes = [
  {
    rfc: "ABC010101ABC",
    razon_social: "ABC Servicios SA de CV",
    auxiliar: "María López",
    estatus: "Activo",
    tareas_abiertas: 3,
  },
  {
    rfc: "XAXX010101000",
    razon_social: "Comercializadora del Norte",
    auxiliar: "—",
    estatus: "Activo",
    tareas_abiertas: 1,
  },
  {
    rfc: "BVL1908211D6",
    razon_social: "Baldemar Consultores",
    auxiliar: "Juan Pérez",
    estatus: "Activo",
    tareas_abiertas: 5,
  },
];

export const mockAuxiliares = [
  { nombre: "María López", correo: "maria.lopez@despacho-demo.local", rol: "Auxiliar", pendientes: 8, vencidas: 1, estatus: "Activo" },
  { nombre: "Juan Pérez", correo: "juan.perez@despacho-demo.local", rol: "Supervisor", pendientes: 12, vencidas: 2, estatus: "Activo" },
  { nombre: "Ana Ruiz", correo: "ana.ruiz@despacho-demo.local", rol: "Auxiliar", pendientes: 6, vencidas: 0, estatus: "Activo" },
];

/** Cupo comercial mock — Fase 2: max_auxiliares desde licencia del comprador. */
export const mockLicenciaAuxiliares = {
  plan: "básico",
  max_autorizados: 5,
  activos: 3,
  disponibles: 2,
};

export const DESPACHO_LIMITE_AUXILIARES_MSG =
  "Has alcanzado el límite de auxiliares autorizados para tu licencia. Solicita ampliación a Soporte BNT.";

export const mockTareas = [
  {
    titulo: "Declaración mensual mayo",
    cliente: "ABC Servicios SA de CV",
    auxiliar: "María López",
    vence: "2026-06-10",
    estatus: "En proceso",
    prioridad: "Alta",
  },
  {
    titulo: "Opinión de cumplimiento",
    cliente: "Baldemar Consultores",
    auxiliar: "Juan Pérez",
    vence: "2026-06-05",
    estatus: "Vencido",
    prioridad: "Alta",
  },
  {
    titulo: "Solicitud de documentos",
    cliente: "Comercializadora del Norte",
    auxiliar: "Ana Ruiz",
    vence: "2026-06-18",
    estatus: "Pendiente",
    prioridad: "Media",
  },
];

export const mockCalendarioDias = [
  { fecha: "2026-06-05", eventos: 2 },
  { fecha: "2026-06-10", eventos: 4 },
  { fecha: "2026-06-15", eventos: 3 },
  { fecha: "2026-06-20", eventos: 1 },
];

export const mockEquipoThreads = {
  general: [
    { autor: "Juan Pérez", texto: "Recordatorio: cerrar pendientes de mayo antes del viernes.", hora: "09:12" },
    { autor: "María López", texto: "Recibido. Tengo 2 clientes con documentos faltantes.", hora: "09:20" },
  ],
  por_cliente: [
    { cliente: "ABC Servicios SA de CV", ultimo: "Falta estado de cuenta — hace 2 h", no_leidos: 2 },
    { cliente: "Baldemar Consultores", ultimo: "Declaración en revisión — ayer", no_leidos: 0 },
  ],
  por_tarea: [
    { tarea: "Declaración mensual mayo", cliente: "ABC SA de CV", ultimo: "Cliente ya envió XML de ventas", no_leidos: 1 },
    { tarea: "Opinión de cumplimiento", cliente: "Baldemar Consultores", ultimo: "Pendiente firma del cliente", no_leidos: 3 },
  ],
};

export const mockSoporteBnt = [
  { categoria: "Licencia", asunto: "Renovación anual — recordatorio 30 días", estado: "Leído", fecha: "2026-06-01" },
  { categoria: "Soporte", asunto: "Consulta sobre respaldo del espacio", estado: "Respondido", fecha: "2026-05-28" },
  { categoria: "Promoción", asunto: "Nuevo módulo Laboral — demo disponible", estado: "Nuevo", fecha: "2026-06-03" },
  { categoria: "Actualización", asunto: "Versión 2.12 — notas de release", estado: "Leído", fecha: "2026-05-20" },
];

export const SOPORTE_BNT_CATEGORIAS = [
  "Soporte",
  "Licencia",
  "Promoción",
  "Aviso",
  "Capacitación",
  "Actualización",
];

export const mockReportes = [
  { titulo: "Tareas vencidas por auxiliar", valor: "Ver desglose", tipo: "tabla" },
  { titulo: "Clientes operativos con más pendientes", valor: "Top 5", tipo: "tabla" },
  { titulo: "Tareas por vencer esta semana", valor: "9", tipo: "kpi" },
  { titulo: "Mensajes sin responder", valor: "4", tipo: "kpi" },
];

/** Orden de prioridad para recordatorios y pendientes (más urgente primero). */
export const DESPACHO_PRIORITY_ORDER = {
  Crítico: 0,
  Urgente: 1,
  Alta: 2,
  Media: 3,
  Baja: 4,
};

export function sortByDespachoPriority(a, b) {
  const pa = DESPACHO_PRIORITY_ORDER[a.prioridad] ?? 99;
  const pb = DESPACHO_PRIORITY_ORDER[b.prioridad] ?? 99;
  return pa - pb;
}

/** Recordatorios globales mock — dueño/supervisor. */
export const mockRecordatoriosDespacho = [
  { id: "r1", tipo: "Opinión de cumplimiento negativa", cliente: "Comercial López SA", prioridad: "Crítico" },
  { id: "r2", tipo: "Declaración mensual por vencer", cliente: "ABC Servicios SA de CV", prioridad: "Urgente" },
  { id: "r3", tipo: "Tarea vencida", cliente: "Baldemar Consultores", prioridad: "Urgente" },
  { id: "r4", tipo: "Declaración anual pendiente", cliente: "Norte Logística", prioridad: "Alta" },
  { id: "r5", tipo: "Cliente sin estados de cuenta", cliente: "Comercializadora del Norte", prioridad: "Alta" },
  { id: "r6", tipo: "Documentos fiscales faltantes", cliente: "Servicios Integrales", prioridad: "Media" },
  { id: "r7", tipo: "Revisión de buzón tributario", cliente: "ABC Servicios SA de CV", prioridad: "Media" },
  { id: "r8", tipo: "Renovación e.firma próxima", cliente: "Baldemar Consultores", prioridad: "Baja" },
  { id: "r9", tipo: "Solicitud pendiente del cliente", cliente: "Comercial López SA", prioridad: "Baja" },
].sort(sortByDespachoPriority);

/** @deprecated Fase 2 — usar buildPendientesPorAuxiliarFromUsers + API /admin/users. */
export const mockPendientesPorAuxiliar = [];

/** @deprecated Usar useDespachoTeamActivity (chat + presencia). */
export const mockActividadEquipo = [];

/** @deprecated Usar /workspace/chat/messages. */
export const mockTeamChatMessages = [];

export const DESPACHO_LIMPIEZA_OPERATIVA_NOTA =
  "Los pendientes permanecen visibles hasta atenderse. Al resolverlos desaparecen del listado activo o pasan a «resueltos recientes». " +
  "Si un auxiliar mantiene limpio su panel, está atendiendo correctamente sus clientes asignados. " +
  "El dueño o supervisor puede dar seguimiento por chat interno cuando un auxiliar acumula pendientes.";

export const DESPACHO_AUXILIAR_VISTA_NOTA =
  "El auxiliar verá únicamente sus propios pendientes y clientes asignados (vista futura: «Mis pendientes»). " +
  "No verá pendientes de otros auxiliares, clientes ajenos ni el resumen global del dueño.";

/** Mensajes demo — chat directo supervisor ↔ auxiliar (sin historial precargado). */
export const mockDirectChatByAuxiliar = {};

/** @deprecated Usar GET /workspace/chat/presence. */
export const mockTeamChatParticipants = [];

/** Bandeja compartida — atención a clientes (tipo WhatsApp Business). */
export const mockClientInboxConversations = [
  {
    id: "cli-1",
    client_name: "Comercial López SA",
    rfc: "CLO850101ABC",
    last_message: "¿Ya quedó la opinión de cumplimiento?",
    status: "Esperando despacho",
    assignee: "Ana López",
    assignee_staff_id: "aux-ana",
    taken_by_staff_id: "aux-ana",
    priority: "Crítico",
    unread_count: 2,
    last_contact_at: "Hoy 10:15",
    allow_general_inbox: false,
    messages: [
      { id: "c1m1", from: "Cliente", text: "Buenos días, ¿tienen avance de la opinión?", at: "Hoy 09:50", inbound: true },
      { id: "c1m2", from: "Ana López", text: "Estamos en revisión con el SAT, le confirmo en la tarde.", at: "Hoy 10:00", inbound: false },
      { id: "c1m3", from: "Cliente", text: "¿Ya quedó la opinión de cumplimiento?", at: "Hoy 10:15", inbound: true },
    ],
  },
  {
    id: "cli-2",
    client_name: "ABC Servicios SA de CV",
    rfc: "ABC010101ABC",
    last_message: "Adjunto estados de cuenta de abril",
    status: "En atención",
    assignee: "María López",
    assignee_staff_id: "aux-maria",
    taken_by_staff_id: "aux-maria",
    priority: "Alta",
    unread_count: 0,
    last_contact_at: "Hoy 08:40",
    allow_general_inbox: true,
    messages: [
      { id: "c2m1", from: "Cliente", text: "Adjunto estados de cuenta de abril", at: "Hoy 08:40", inbound: true },
      { id: "c2m2", from: "María López", text: "Recibido, los integraré a la declaración.", at: "Hoy 08:55", inbound: false },
    ],
  },
  {
    id: "cli-3",
    client_name: "Comercializadora del Norte",
    rfc: "XAXX010101000",
    last_message: "Necesito factura del mes pasado",
    status: "Nuevo",
    assignee: "—",
    assignee_staff_id: "",
    taken_by_staff_id: "",
    priority: "Urgente",
    unread_count: 1,
    last_contact_at: "Hoy 11:02",
    allow_general_inbox: true,
    messages: [
      { id: "c3m1", from: "Cliente", text: "Necesito factura del mes pasado", at: "Hoy 11:02", inbound: true },
    ],
  },
  {
    id: "cli-4",
    client_name: "Baldemar Consultores",
    rfc: "BVL1908211D6",
    last_message: "Gracias, quedó resuelto.",
    status: "Resuelto",
    assignee: "Juan Pérez",
    assignee_staff_id: "aux-juan",
    taken_by_staff_id: "aux-juan",
    priority: "Media",
    unread_count: 0,
    last_contact_at: "Ayer 17:30",
    allow_general_inbox: false,
    messages: [
      { id: "c4m1", from: "Juan Pérez", text: "La DIOT ya fue presentada.", at: "Ayer 17:20", inbound: false },
      { id: "c4m2", from: "Cliente", text: "Gracias, quedó resuelto.", at: "Ayer 17:30", inbound: true },
    ],
  },
];

